import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";
import {GlobalResolveAction} from "../utils/resolveDifference";

// Applies a batch of global-field writes atomically (one undo reverts them
// all). Produced when the user resolves a row in the Game Settings section.
export class ResolveGlobalFieldCommand extends CommandBase {
    actions: GlobalResolveAction[];

    constructor(actions: GlobalResolveAction[]) {
        super();
        this.actions = actions;
    }

    execute(data: RemoteConstantsModel): boolean {
        let mutated = false;
        for (const a of this.actions) {
            if (applyAction(data as unknown as Record<string, unknown>, a)) mutated = true;
        }
        return mutated;
    }
}

function applyAction(root: Record<string, unknown>, a: GlobalResolveAction): boolean {
    if (a.path.length === 0) return false;
    const segs = a.path.slice(0, -1);
    const leaf = a.path[a.path.length - 1];

    let parent: Record<string, unknown> = root;
    for (const seg of segs) {
        if (typeof parent[seg] !== 'object' || parent[seg] === null) parent[seg] = {};
        parent = parent[seg] as Record<string, unknown>;
    }

    switch (a.kind) {
        case 'scalar': {
            if (a.value === undefined) {
                if (!(leaf in parent)) return false;
                delete parent[leaf];
                return true;
            }
            if (JSON.stringify(parent[leaf]) === JSON.stringify(a.value)) return false;
            parent[leaf] = JSON.parse(JSON.stringify(a.value));
            return true;
        }
        case 'set-add': {
            if (!Array.isArray(parent[leaf])) parent[leaf] = [];
            const arr = parent[leaf] as unknown[];
            if (arr.includes(a.value)) return false;
            arr.push(a.value);
            return true;
        }
        case 'set-remove': {
            if (!Array.isArray(parent[leaf])) return false;
            const arr = parent[leaf] as unknown[];
            const before = arr.length;
            parent[leaf] = arr.filter(v => v !== a.value);
            return (parent[leaf] as unknown[]).length !== before;
        }
        default:
            // obj-add / obj-remove never arise for globals (no uid-object arrays).
            return false;
    }
}
